<script>
    import $ from "jquery";
    export default {
        name: 'PermissionsApp',
        data: function() {
            return { 
                loading: true,
                blocks: [],
                sites: [],
                hints: [],
                emptyhints: [],
                text: '',
                permissionsAvailable: [],
                permissions: [],
                userPermissions: [],
            }
        },
        watch: {
            sites: {
                handler: function(newval, oldval) {
                    let ids = [];
                    let newPermissions = [];

                    for (let site of this.sites) {
                        ids.push(site.value);
                    }

                    for (let perm of this.permissions) {
                        let permid = parseInt((perm.split(':')[0]).split('-')[1]);
                        if (ids.includes(permid)) {
                            newPermissions.push(perm);
                        }
                    }
                    this.permissions = newPermissions;
                },
            },
        },
        mounted: function() {
            this.loadEmptyHints();
            this.permissionsAvailable = JSON.parse(this.$root.$el.dataset.permissions);
            this.permissions = JSON.parse(this.$root.$el.dataset.userPermissions)

            let checkedPermissions = []; 
            let checkedSites = {};
            let siteLabels = JSON.parse(this.$root.$el.dataset.sites);
            for (let perm of this.permissions) {
                let id = (perm.split(':')[0]).split('-')[1];
                if (!Object.keys(checkedSites).includes(id)) {
                    checkedSites[id] = {};
                }
                checkedSites[id];
            }
            for (let [site, permissions] of Object.entries(checkedSites)) {
                let elem = {'value': parseInt(site), 'label': siteLabels[site]};
                this.sites.push(elem);
            }
        },
        methods: {
            loadEmptyHints: function() {
                let cmp = this;
                $.ajax({
                    type: "POST",
                    url: '/admin/siteshint/?q=',
                    success: function ( data ) {
                        cmp.hints = data.hints;
                        cmp.emptyhints= data.hints;
                    },
                    error: function(error) {
                    }
                });
            },
            loadHints: function(text, loading) {
                let cmp = this;
                clearTimeout(cmp.timeout);
                loading(true);
                cmp.timeout = setTimeout(function() {
                    $.ajax({
                        type: "POST",
                        url: '/admin/siteshint/?q='+encodeURIComponent(text),
                        success: function ( data ) {
                            cmp.hints = data.hints;
                            loading(false);
                        },
                        error: function(error) {
                            loading(false);
                        }
                    });
                }, 100);
            },
            loadAllHints: function(e) {
                if (!this.$refs.vselect.$refs.search.value) {
                    this.hints = this.emptyhints;
                }
            },
        }
    }
</script>
